import { render, staticRenderFns } from "./政策法规.vue?vue&type=template&id=92ff52aa&scoped=true"
import script from "./政策法规.vue?vue&type=script&lang=js"
export * from "./政策法规.vue?vue&type=script&lang=js"
import style0 from "./政策法规.vue?vue&type=style&index=0&id=92ff52aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ff52aa",
  null
  
)

export default component.exports